import { PathOptions } from "leaflet";

export const estados_bra = (feature: any): PathOptions => {
  return {
    color: "#555555",
    weight: 2,
    opacity: 0.6,
    fillColor: "transparent",
    fillOpacity: 0,
  };
};
